import type { MouseEvent } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

type AppNavLinkProps = Parameters<typeof NavLink>[0] & {
  beforeNavigate?: () => boolean
}

export function AppNavLink({ beforeNavigate, onClick, ...props }: AppNavLinkProps) {
  const currentLocation = useLocation()

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event)

    if (event.defaultPrevented) {
      return
    }

    if (beforeNavigate && beforeNavigate() !== true) {
      event.preventDefault()
    }
  }

  if (props.replace === true) {
    const overrides = {
      state: {
        ...currentLocation.state,
        ...(props.state ? props.state : {}),
      },
      onClick: handleClick,
    }
    return <NavLink {...props} {...overrides} />
  } else {
    // disable the dumb 'replace if same path behavior'
    const overrides = {
      replace: false,
      onClick: handleClick,
    }
    return <NavLink {...props} {...overrides} />
  }
}
